<!-- eslint-disable -->
<template lang="pug">
    modal-frame.submarine-modal(
        :displayModal="displayModal"
         @close="$emit('close')"
         @open="$emit('open')"
    )
        submarine(slot="body")
</template>

<script>
    /*eslint-disable*/
    import Submarine from './map-assets/submarine/Index.vue'
    import ModalFrame from '../modals/map/ModalFrame.vue'

    export default {
        props: {
            displayModal: Boolean
        },
        components: {
            Submarine,
            ModalFrame
        }
    }
</script>

<style lang="scss">
    .submarine-modal {
        .modal-card {
            @media screen and (min-width: 769px) {
                width: 640px;
            }
        }

        .modal-card-body {
            overflow: hidden;
            flex-grow: 1;
            flex-shrink: 1;
            padding: 20px 20px 0;
                @media screen and (min-width: 1000px){
                    min-height: 418px;
                }
        }
    }
</style>